import { useMutation } from "urql";

import { UpdateLimitRequestConditionPrecedentDocument } from "../../../graphql/generated.ts";

export function useUpdateLimitRequestConditionPrecedent() {
  return useMutation(UpdateLimitRequestConditionPrecedentDocument);
}
